module.exports = __webpack_public_path__ + "assets/add-on-illustrations-adapter-03.c5ffda5d.svg";